export const environment = {
  production: false,
  title: 'TYT',
  
  defaultCredentials: {
    email: 'admin@tyt.com',
    password: ''
  }
};
